/* eslint-disable */
import swal from "sweetalert2/dist/sweetalert2.all.min.js";

export default {
  methods: {
    sweetAlertError(message) {
      let error = "";
      if (Array.isArray(message)) {
        error += `<ul>`;
        for (let i = 0; i < message.length; i++) {
          error += `<li>${this.$t(message[i])}</li>`;
        }
        error += `</ul>`;
      } else if (typeof message === "object") {
        error += `<ul>`;
        for (let key in message) {
          let currentValue = message[key];
          error += `<li><b>${this.$t(key)} : </b> ${this.$t(
            currentValue
          )}</li>`;
        }
      } else if (typeof message === "string") {
        error = this.$t(message);
      }
      let self = this;
      return swal
        .fire({
          icon: "error",
          title: "Oops...",
          html: this.$t(error)
        })
        .then(() => {
          if (self.setLoading !== undefined) {
            self.setLoading(false);
          }
        });
    },
    sweetAlertWarning(warning) {
      let self = this;
      swal
        .fire({
          icon: "warning",
          html: this.$t(warning)
        })
        .then(() => {
          if (self.setLoading !== undefined) {
            self.setLoading(false);
          }
        });
    },
    sweetAlertSuccess(successMessage, callBack = null, configs = {}) {
      let self = this;
      let options = {
        icon: 'success',
        title: this.$t("general.congratulation"),
        html: this.$t(successMessage),
        confirmButtonText: this.$t("general.ok").toUpperCase(),
        className: "rounded-full",
        confirmButtonClass: "btn btn-outline-primary btn-pill confirm-text-white"
        // customClass: {
        //     confirmButton: ' btn btn-outline-dark rounded-full'
        // },
        // buttons: {
        //     confirm : {text:this.$t('general.ok').toUpperCase(),className:'btn btn-outline-dark'},
        //     cancel : {text:this.$t('general.ok'),className:'btn btn-outline-success'},
        //     ok: {text:this.$t('general.ok').toUpperCase(), className:'btn btn-outline-dark'}
        // },
      };
      return swal
        .fire({
          ...options,
          ...configs
        })
        .then(function () {
          if (self.setLoading !== undefined) {
            self.setLoading(false);
          }
          if (callBack === null) {
            return true;
          }
          callBack(self);
        });
    },
    sweetAlertConfirm(
      message,
      confirmCallback = null,
      cancelCallback = null,
      configs = {}
    ) {
      let self = this;
      let options = {
        html: this.$t(message),
        type: "warning",
        showCancelButton: true,
        confirmButtonText: self.$t("general.yes_delete_it"),
        cancelButtonText: self.$t("general.no_cancel_it"),
        confirmButtonClass: "btn btn-outline-primary btn-pill color-primary mr-1",
        cancelButtonClass: "btn btn-outline-danger btn-pill",
        buttonsStyling: false
      };
      if (!("imageUrl" in configs)) {
        options["icon"] = "warning";
      }
      if ("yes" in configs) {
        options.confirmButtonText = configs.yes;
      }
      if ("no" in configs) {
        options.cancelButtonText = configs.no;
      }
      return swal.fire({ ...options, ...configs }).then(function (result) {
        if (result.isConfirmed) {
          if (confirmCallback) {
            confirmCallback(self);
          }
          return true;
        } else {
          if (cancelCallback) {
            cancelCallback(self);
          }
          return false;
        }
      });
    },
    sweetAlertLoading() {
      return false;
      swal.fire({
        imageUrl: this.mediaBase + "/logos/logo-letter-1.png",
        type: "success",
        title: this.$t("general.processing"),
        allowOutsideClick: false,
        showCancelButton: false,
        showConfirmButton: false,
        onBeforeOpen: () => {
          swal.showLoading();
        }
      });
    },
    sweetAlertClose() {
      setTimeout(() => {
        $(document).find("#content-loading").attr('style', 'height: 100vh; display: none !important');
        $(document).find("#content-loading-except").removeClass("content-blur");
      }, 100);
    }
  },
  watch: {
    loading(newValue, oldValue) {
      if (newValue === oldValue) {
        $(document).find("#loader").attr('style', 'height: 100vh; display: none !important');
        $(document).find("#content-except-loader").removeClass("content-blur");
        return;
      }
      if (newValue === true) {
        $(document).find("#loader").attr('style', 'height: 100vh; display: inherit');
        $(document).find("#content-except-loader").addClass("content-blur");
      } else {
        setTimeout(() => {
          $(document).find("#loader").attr('style', 'height: 100vh; display: none !important');
          $(document).find("#content-except-loader").removeClass("content-blur");
        }, 100);
      }
    },
    success(newValue, oldValue) {
      if (typeof newValue === "string") {
        this.sweetAlertClose()
        this.sweetAlertSuccess(this.$t(newValue));
      } else {
        setTimeout(() => swal.close(), 500);
      }
    },
    error(newValue, oldValue) {
      if (newValue != null && !this.disabledErrorPopUp) {
        this.sweetAlertClose()
        this.sweetAlertError(newValue);
      }
    }
  },

  computed: {
    mediaBaseUrl() {
      return process.env.VUE_APP_MEDIA_URL;
    }
  }
};
